import { TITLE_TO_ALIAS } from 'common/constants/cap-table';

export const CAPTABLE = (fieldName: string, securityId: string) => {
  const { appGlobal } = window as any;
  if (appGlobal?.capTable?.securities) {
    // Find the security passed as an argument
    const selectedSecurity = appGlobal.capTable.securities.find(
      (security: any) => security.id.toString() === securityId.toString()
    );

    // Locate and return the field-name value
    if (selectedSecurity) {
      return selectedSecurity[TITLE_TO_ALIAS[fieldName as keyof typeof TITLE_TO_ALIAS]];
    }
  }

  return null;
};

export const CAPTABLETOTAL = (fieldName: string) => {
  const { appGlobal } = window as any;
  if (appGlobal?.capTable?.[TITLE_TO_ALIAS[fieldName as keyof typeof TITLE_TO_ALIAS]]) {
    return appGlobal.capTable[TITLE_TO_ALIAS[fieldName as keyof typeof TITLE_TO_ALIAS]];
  }
  return null;
};
